const mainUserWayScript = `(function (d) {
  var s = d.createElement("script");
  s.setAttribute("data-account", "W1vCwurRy6");
  s.setAttribute("src", "https://cdn.userway.org/widget.js");
  (d.body || d.head).appendChild(s);
})(document)`;

export { mainUserWayScript };
